var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-wrapper",on:{"click":_vm.emitButtonClick}},[_c('div',{staticClass:"heart",class:{ '-filled': _vm.buttonActive }}),_c('div',{staticClass:"animation",class:{ '-active': _vm.buttonActive }})])}
var staticRenderFns = []

export { render, staticRenderFns }